import React, { Fragment } from 'react'
import { Route } from 'react-router-dom'
import ComponentTypes from './ComponentTypes'
import ComponentGroups from './ComponentGroups'
import ActivityTypes from './ActivityTypes'
import LossReasons from './LossReasons'
import CheckLists from './CheckLists'

const ManageManufacturing = ({ match }) => {
  return (
    <Fragment>
      <Route exact path={`${match.url}/componenttypes`} component={ComponentTypes} />
      <Route exact path={`${match.url}/componentgroups`} component={ComponentGroups} />
      <Route exact path={`${match.url}/activitytypes`} component={ActivityTypes} />
      <Route exact path={`${match.url}/lossreasons`} component={LossReasons} />
      <Route exact path={`${match.url}/checklists`} component={CheckLists} />
    </Fragment>
  )
}

export default ManageManufacturing



// WEBPACK FOOTER //
// ./src/containers/Settings/Manufacturing/index.js